// extracted by mini-css-extract-plugin
export var childrenContainer = "_4g-0";
export var virtualScrollArea = "_4g-1";